import Resource from './Resource';
import Attributes from 'Attributes/ListViewAttributes';

const handleDataArray = (parser, res) => {
	return { ...res.data, data: res.data.data.map(parser) };
};

class ListViews extends Resource {
	constructor() {
		super('listViews', Attributes);
	}

	// Fetch a single page of shared-capable list views; server will filter/compute shared (and optional query)
	async getSharedPaged({ limit, offset, query }) {
		const parseResponse = handleDataArray.bind(this, this._parse.bind(this));
		const response = await this._getRequest('all/', {
			methodName: 'getSharedPaged',
			params: {
				limit,
				offset,
				query
			}
		});
		const parsed = parseResponse(response);
		return parsed;
	}

	getShared() {
		return this._getRequest('all/', { methodName: 'getShared' }).then(
			handleDataArray.bind(this, this._parse.bind(this))
		);
	}
}

const resource = new ListViews();
window.Tools.ListViews = resource;
export default resource;
